import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

interface ParamsValidationResult {
	params: Record<string, string | undefined>;
	paramsError: string | null;
}

const useValidatedParams = ({
	paramNames,
	errorMessage,
}: {
	paramNames: string[];
	errorMessage: string;
}): ParamsValidationResult => {
	const params = useParams();
	const [paramsError, setParamsError] = useState<string | null>(null);

	useEffect(() => {
		paramNames.forEach((paramName) => {
			if (!paramName || !params[paramName]) {
				setParamsError(errorMessage);
			}
		});
	}, [params, paramNames, errorMessage]);

	return { params, paramsError };
};

export default useValidatedParams;
